import Vue from 'vue';
import { LazyYoutube } from 'vue-lazytube';
Vue.component('LazyYoutube', LazyYoutube);
